import { Flex, FlexProps, Spacer, Tag, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";

export function FlightSummaryHeader({
  airlineName,
  airlineCode,
  disruptionReason,
  flightNumber,
  ...props
}: FlexProps & {
  airlineName?: string;
  airlineCode?: string;
  disruptionReason: "delayed" | "cancelled";
  flightNumber?: string;
}) {
  const { t } = useTranslation();

  const flightLabel = [airlineName, flightNumber && airlineName && " - ", airlineCode, flightNumber]
    .filter(Boolean)
    .join("");

  const desktopFlightLabel = () => (
    <Flex align="center">
      <Text fontSize="sm" color="greyscale.500">
        {t("steps.itinerary_details.airline")}:
        <Text fontWeight="bold" color="greyscale.600" mr={6} ml={1} as="span" fontSize="sm">
          {airlineName}
        </Text>
      </Text>

      <Text fontSize="sm" color="greyscale.500">
        {t("steps.itinerary_details.flight_number")}:
        <Text fontWeight="bold" color="greyscale.600" ml={1} as="span" fontSize="sm">
          {flightNumber}
        </Text>
      </Text>
    </Flex>
  );
  return (
    <Flex w="full" px={{ base: 4, md: 6 }} py={{ base: 3, md: 4 }} alignItems="center" {...props}>
      {isMobile ? flightLabel : desktopFlightLabel()}
      <Spacer />
      <Tag
        size="xs"
        colorScheme={disruptionReason === "delayed" ? "warning" : "danger"}
        variant="secondary"
        data-testid="flight-summary-header-disruption-reason"
      >
        {t(`steps.disrupted_flight_detected.${disruptionReason}.status`).toUpperCase()}
      </Tag>
    </Flex>
  );
}
